import { all, call, put, takeLatest } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import * as api from './api';
import * as types from './constants';

function* listCustomerProductRatingsSaga() {
  try {
    yield call(removeAPIError);
    const custId = customerId();
    if (!custId) return;
    const response = yield call(api.listProductRatings, custId);
    yield put({
      type: types.CUSTOMER_PRODUCT_RATING_LIST_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: types.CUSTOMER_PRODUCT_RATING_LIST_FAILURE, error });
    yield call(addAPIError, error);
  }
}

function* likeCustomerProductRatingSaga(action) {
  try {
    yield call(removeAPIError);
    const custId = customerId();
    if (!custId) return;
    const response = yield call(
      api.addProductRatingLike,
      custId,
      action.productId
    );

    yield put({
      type: types.CUSTOMER_PRODUCT_RATING_LIKE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: types.CUSTOMER_PRODUCT_RATING_LIKE_FAILURE, error });
    yield call(addAPIError, error);
  }
}

function* dislikeCustomerProductRatingSaga(action) {
  try {
    yield call(removeAPIError);
    const custId = customerId();
    if (!custId) return;
    const response = yield call(
      api.addProductRatingDislike,
      custId,
      action.productId
    );
    yield put({
      type: types.CUSTOMER_PRODUCT_RATING_DISLIKE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: types.CUSTOMER_PRODUCT_RATING_DISLIKE_FAILURE, error });
    yield call(addAPIError, error);
  }
}

function* deleteCustomerProductRatingSaga(action) {
  try {
    yield call(removeAPIError);
    const custId = customerId();
    if (!custId) return;
    yield call(api.deleteProductRating, custId, action.productId);
    yield put({
      type: types.CUSTOMER_PRODUCT_RATING_DELETE_SUCCESS,
      productId: action.productId
    });
  } catch (error) {
    yield put({ type: types.CUSTOMER_PRODUCT_RATING_DELETE_FAILURE, error });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(
    types.CUSTOMER_PRODUCT_RATING_LIST_REQUEST,
    listCustomerProductRatingsSaga
  );
  yield takeLatest(
    types.CUSTOMER_PRODUCT_RATING_LIKE_REQUEST,
    likeCustomerProductRatingSaga
  );
  yield takeLatest(
    types.CUSTOMER_PRODUCT_RATING_DISLIKE_REQUEST,
    dislikeCustomerProductRatingSaga
  );
  yield takeLatest(
    types.CUSTOMER_PRODUCT_RATING_DELETE_REQUEST,
    deleteCustomerProductRatingSaga
  );
}

export default function* customerProductRatingSagas() {
  yield all([watchList()]);
}
